import { AddressFormData } from 'src/app/_widgets/address-form/address-form-data';
import { BeLiberoProfessionista } from './be-professionista';
import { IFactory, PGEndpointPath } from './i-factory';
import { Impresa } from './impresa';
import {
  LiberoProfessionista,
  TipoContrattoLavoroEnum,
} from './libero-professionista';

export class ProfessionistaFactory
  implements IFactory<BeLiberoProfessionista, LiberoProfessionista>
{
  toView(data: BeLiberoProfessionista) {
    let p: LiberoProfessionista = {
      nome: data.nome,
      cognome: data.cognome,
      ateco: data.ateco,
      denominazione: data.denominazione,
      id: data.id,
      numeroDipendenti: data.numeroDipendenti,
      partitaIva: data.partitaIva,
      pec: data.pec,
      tipoContabilita: 'Semplificata',
      tipoSoggetto: 'LP',
      iban: data.iban,
      dataIscrizioneAlbo: new Date(data.dataIscrizioneAlbo),
      formaGiuridica: data.formaGiuridica,
      codiceAteco: data.codiceAteco,
      confermaPec: data.confermaPec,
      indiciReputazionaliNegativi: data.indiciReputazionaliNegativi,
      iscrizioneAlbo: data.iscrizioneAlbo,
      numeroIscrizioneAlbo: data.numeroIscrizioneAlbo,
      settoreAttivita: data.settoreAttivita || 'Servizi privati',
      sezioneAteco: data.sezioneAteco,
      annoRilevazioneDipendenti: data.annoRilevazioneDipendenti,
      codiceFiscale: data.codiceFiscale,
      situazioneAbitativa: data.situazioneAbitativa,
      affitto: data.affitto,

      capitaleSocialeDeliberato: data.capitaleSocialeDeliberato,
      capitaleSocialeVersato: data.capitaleSocialeVersato,

      professione: data.professione,
      presenzaListeAntiterrorismo: data.presenzaListeAntiterrorismo,
      kic: data.kic,

      location: {
        street_number: data.civicoSedeLegale,
        route: data.indirizzoSedeLegale,
        postal_code: data.capSedeLegale,
        administrative_area_level_2: data.provinciaSedeLegale,
        administrative_area_level_3: data.comuneSedeLegale,
        country: data.paeseSedeLegale,
      },

      extension: data.extension,

      sae: data.sae,
      modalitaIdentificazione: data.modalitaIdentificazione,
    };
    return p;
  }

  toDomain(
    professionista: Partial<LiberoProfessionista>,
    tipoContabilita: Impresa['tipoContabilita'],
    kycData: Impresa['kic'] | undefined,
    location: Partial<AddressFormData>,
    extension: Record<string, any>
  ) {
    let p: Partial<BeLiberoProfessionista> = {
      annoRilevazioneDipendenti: professionista.annoRilevazioneDipendenti,
      codiceAteco: professionista.codiceAteco,
      cognome: professionista.cognome,
      confermaPec: professionista.confermaPec,
      dataIscrizioneAlbo: professionista.dataIscrizioneAlbo?.valueOf(),
      iscrizioneAlbo: professionista.iscrizioneAlbo,
      nome: professionista.nome,
      numeroIscrizioneAlbo: professionista.numeroIscrizioneAlbo,
      settoreAttivita: professionista.settoreAttivita,
      sezioneAteco: professionista.sezioneAteco,
      ateco: professionista.ateco,
      codiceFiscale: professionista.codiceFiscale,
      denominazione: professionista.denominazione,
      indiciReputazionaliNegativi: professionista.indiciReputazionaliNegativi,
      id: professionista.id,
      numeroDipendenti: professionista.numeroDipendenti,
      partitaIva: professionista.partitaIva,
      pec: professionista.pec,
      formaGiuridica: professionista.formaGiuridica,
      civicoSedeLegale: location.street_number,
      indirizzoSedeLegale: location.route,
      capSedeLegale: location.postal_code,
      provinciaSedeLegale: location.administrative_area_level_2,
      comuneSedeLegale: location.administrative_area_level_3,
      paeseSedeLegale: location.country,
      situazioneAbitativa: professionista.situazioneAbitativa,
      affitto: professionista.affitto,
      iban: professionista.iban,
      professione: professionista.professione,
      presenzaListeAntiterrorismo: professionista.presenzaListeAntiterrorismo,
      kic: kycData,
      sae: professionista.sae,
      modalitaIdentificazione: professionista.modalitaIdentificazione,
    };
    if (extension) {
      p.extension = extension;
    }
    return p;
  }

  endpointPath: PGEndpointPath = 'libero-professionista';
}
